module.exports = __webpack_public_path__ + "img/icon-datetime.25498852.svg";